export const TRAINING_CONSECUTIVE_FAIL_THRESHOLDS = [5, 4, 3, 2];

function parseDateForSort(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return 0;
  const m = dateStr.trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return 0;
  const dd = parseInt(m[1], 10);
  const mm = parseInt(m[2], 10);
  const yyyy = parseInt(m[3], 10);
  return new Date(yyyy, mm - 1, dd).getTime();
}

function parseTimeForSort(timeStr) {
  if (!timeStr || typeof timeStr !== "string") return 0;
  const parts = timeStr.trim().split(":");
  if (parts.length < 2) return 0;
  const hh = parseInt(parts[0], 10);
  const mm = parseInt(parts[1], 10);
  if (!Number.isFinite(hh) || !Number.isFinite(mm)) return 0;
  return hh * 60 + mm;
}

/** Nombre d'échecs consécutifs depuis la partie la plus récente. */
export function getConsecutiveFailCount(stats) {
  const last5 = stats?.last5Games;
  if (!Array.isArray(last5) || !last5.length) return 0;

  const sorted = [...last5].sort((a, b) => {
    const dateDiff = parseDateForSort(b.date) - parseDateForSort(a.date);
    if (dateDiff !== 0) return dateDiff;
    return parseTimeForSort(b.time) - parseTimeForSort(a.time);
  });

  let count = 0;
  for (const entry of sorted) {
    if (entry?.result === "fail") count += 1;
    else break;
  }

  return count;
}

export function wordMatchesConsecutiveFailsFilter(word, enabled, threshold) {
  if (!enabled) return true;

  const minFails = Number(threshold);
  if (!TRAINING_CONSECUTIVE_FAIL_THRESHOLDS.includes(minFails)) return false;

  return getConsecutiveFailCount(word?.stats) >= minFails;
}
